import { PageFormValidationSchema } from '../../../pages.interfaces';

export const pagesValidationSchema: PageFormValidationSchema = {
  title: [
    { required: true, message: 'Введіть заголовок сторінки' },
    { type: 'string', message: 'Заголовок має бути строкою' },
    { min: 1, max: 255, message: 'Заголовок має бути довжиною не менше 1 символа та не більше 255' }
  ],
  publishedAt: [{ required: false, message: 'Введіть дату публікації', type: 'date' }],
  structureNodeId: [],
  usageFor: [{ required: true, message: 'Виберіть призначення сторінки' }],
  body: [{ type: 'string', message: 'Контент має бути строкового типу' }, { required: false }],
  layoutId: [{ required: false, type: 'string', message: 'Виберіть макет для сторінки' }]
};
